import { Node } from 'reactflow'

import { NodeStep, NodeType, SliceHealthStatus } from '@ui/__generated__/graphql'

import { codeDefault } from './createDefaultNodesAndEdges'

export const createNode = ({
  nodeId,
  nodeType,
  parentNodeId,
  description,
  code,
  steps,
  undeletable,
}: {
  nodeId: string
  nodeType: NodeType
  parentNodeId?: string
  description?: string
  code?: string
  undeletable?: boolean
  steps?: NodeStep[]
}): Node => {
  const newNode: Node = {
    id: nodeId,
    position: {
      x: 0,
      y: 0,
    },
    type: nodeType,
    data: {
      description: description || '',
      sliceId: undefined,
      parentSliceId: parentNodeId,
      code: code ?? codeDefault,
      undeletable: undeletable || false,
      modified: true,
      status: {
        logsEnabled: true,
        spansEnabled: true,
        metricsEnabled: true,
        logsStatus: SliceHealthStatus.Enabled,
        spansStatus: SliceHealthStatus.Enabled,
        metricsStatus: SliceHealthStatus.Enabled,
      },
      size: {
        span: 0,
        log: 0,
        metric: 0,
      },
      steps:
        steps ||
        [
          // {
          //   id: '1',
          //   type: StepTypeEnum.FILTER,
          //   description: 'Step to filter the data',
          //   logsEnabled: true,
          //   metricsEnabled: true,
          //   spansEnabled: true,
          //   order: 0,
          // },
          // {
          //   id: '2',
          //   type: StepTypeEnum.DROP,
          //   description: 'Step to drop the data',
          //   logsEnabled: true,
          //   metricsEnabled: true,
          //   spansEnabled: true,
          //   order: 1,
          // },
          // {
          //   id: '3',
          //   type: StepTypeEnum.SAMPLE,
          //   description: 'Step to sample the data',
          //   logsEnabled: true,
          //   metricsEnabled: true,
          //   spansEnabled: true,
          //   order: 2,
          // },
          // {
          //   id: '4',
          //   type: StepTypeEnum.REGEX,
          //   description: 'Step to regex the data',
          //   logsEnabled: true,
          //   metricsEnabled: true,
          //   spansEnabled: true,
          //   order: 3,
          // },
          // {
          //   id: '5',
          //   type: StepTypeEnum.CODE,
          //   description: 'Step to code the data',
          //   logsEnabled: true,
          //   metricsEnabled: true,
          //   spansEnabled: true,
          //   order: 4,
          // },
        ],
    },
  }

  return newNode
}
